/* eslint-disable @typescript-eslint/no-explicit-any */
import { put } from 'redux-saga/effects'
import { Map } from 'features/maps/types'
import { showGlobalBuilderError } from './builderSlice'
import { setMapSettings } from 'features/maps/state/mapsSlice'
import { getLocalStorageItem } from 'app/api/localStorage'
import { BUILDER_MEASURE_TOOL_UNIT_KEY, DistanceUnits } from '../types'

export function* loadMapSettings(currentMap: Map) {
  try {
    let mapSettings = currentMap.keplerMapConfig?.config?.mapSettings
    const legendSettings = currentMap.keplerMapConfig?.config.legendSettings
    if (!mapSettings) {
      return
    }

    if (legendSettings && legendSettings.baseMapSelector) {
      const { baseMapSelector } = legendSettings
      mapSettings = { ...mapSettings }
      mapSettings.basemapsSelector = baseMapSelector
    }

    if (mapSettings.sqlParameterControls === undefined && mapSettings.showDateControl !== undefined) {
      const { showDateControl, ...newMapSettings } = mapSettings
      mapSettings = newMapSettings
      mapSettings.sqlParameterControls = showDateControl
    }

    if (mapSettings.measurementUnit === undefined) {
      const storedMeasurementUnit = getLocalStorageItem(BUILDER_MEASURE_TOOL_UNIT_KEY)
      mapSettings = {
        ...mapSettings,
        measurementUnit: storedMeasurementUnit || DistanceUnits.Kilometers
      }
    }

    yield put(setMapSettings(mapSettings))
  } catch (e: any) {
    yield put(showGlobalBuilderError(e.message))
  }
}
